module.exports = __webpack_public_path__ + "img/home_background.5d073376.jpg";